import React from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

interface CartErrorDialogProps {
  open: boolean;
  onClose: () => void;
  error: {
    success: false;
    message: string;
    error: string;
    availableQuantity?: number;
    locations?: Array<{
      id: number;
      name: string;
      availableQuantity: number;
    }>;
  } | null;
}

const CartErrorDialog: React.FC<CartErrorDialogProps> = ({ open, onClose, error }) => {
  if (!error) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 3,
          position: 'relative',
        },
      }}
    >
      {/* Close Button */}
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: '#666',
          '&:hover': {
            color: '#333',
          },
        }}
      >
        <CloseIcon />
      </IconButton>
      
      <DialogContent sx={{ p: 0, textAlign: 'center' }}>
        <Typography variant="body1" color="text.primary">
          {error.message}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default CartErrorDialog;
